<div class="OlivorStore">
  <section class="oliverContactus">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2>Contact us</h2>
          <p>We're happy to answer questions or help you with returns. Please fill out the form below if you need
            assistance.</p>
          <form>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Full name" required>
            </div>
            <div class="form-group">
              <input type="tel" class="form-control" placeholder="Phone number">
            </div>
            <div class="form-group">
              <input type="tel" class="form-control" placeholder="Email" required>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Order number">
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Company name">
            </div>
            <div class="form-group">
              <input type="text" class="form-control" placeholder="RMA Number">
            </div>
            <div class="form-group">
              <textarea name="comments" id="comments" class="form-control" required
                placeholder="Comments/Questions"></textarea>
            </div>
            <div>
              <p>You may receive marketing and promotional materials. Contact the merchant for their privacy practices.
              </p>
              <p class="ligtText">This form is protected by reCAPTCHA and the Google <a href="#">Privacy Policy</a> and
                <a href="#">Terms of Service apply</a>.
              </p>
            </div>
            <div>
              <button class="btn btn-default">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>